<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>PART ONE</span></p>
<p class="center"><span>“Notre vie intérieure n’est pas une mathématique, mais une histoire. Nous ne vivons pas dans l’espace, mais dans le monde des âmes.”</span></p>
<p class="center-a"><span>HENRI BERGSON</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?76a380ca